// @core/api/endpoints/authn/get_oauth2_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OAuth2ProviderResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Get OAuth2 provider details
 * Retrieves configuration for a specific OAuth2 identity provider. Does not return the client secret for security reasons.
 */
export async function GetOAuth2Provider(
  provider_id: string,
  options?: RequestOptions
): Promise<OAuth2ProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/providers/:provider_id`;
  requestPath = requestPath.replace(':provider_id', encodeURIComponent(provider_id));
  const requestOptions = options;
  return client.get<OAuth2ProviderResponse>(requestPath, { ...requestOptions });
}
